import React from 'react';
import { Theme, Typography, Button } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { ButtonProps } from '@mui/material/Button';
import { WithTranslation, withTranslation } from 'react-i18next';

import { NextIcon } from 'assets/icons';

interface NextButtonProps extends WithStyles<typeof styles>, WithTranslation {
    buttonProps?: ButtonProps;
    title?: string;
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            height: '88px',
            minWidth: '360px',
        },
        icon: {
            marginLeft: '92px',
        },
        label: {
            marginLeft: '55px',
        },
    });

class NextButton extends React.Component<NextButtonProps, any> {
    render() {
        const { classes, t, title, buttonProps } = this.props;

        return (
            <Button
                classes={{
                    endIcon: classes.icon,
                    root: classes.root,
                }}
                endIcon={<NextIcon colorType='primary' />}
                variant='primary'
                {...buttonProps}
            >
                <Typography className={classes.label} variant='button'>
                    {title || t('Next')}
                </Typography>
            </Button>
        );
    }
}

export default withTranslation()(withStyles(styles)(NextButton));
